import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxMaskModule } from 'ngx-mask';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';

import { ClientService } from './services/client';
import { DocumentService } from './services/document';
import { ImmediateCancellationService } from './services/immediateCancellation';
import { KinshipService } from './services/kinship';

import { ComponentsModule } from 'src/app/core/components/components.module';
import { DadosCadastraisRoutingModule } from './dados-cadastrais-routing.module';

import { MatPaginatorModule } from '@angular/material/paginator';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AlteracaoCadastralComponent } from './components/alteracao-cadastral';
import { BeneficiaryBlockComponent } from './components/beneficiary-block/beneficiary-block.component';
import { BeneficiaryDocumentsComponent } from './components/beneficiary-documents';
import { BeneficiaryDocumentInputComponent } from './components/beneficiary-documents/beneficiary-document-input';
import { BeneficiaryFormComponent } from './components/beneficiary-form';
import { BeneficiaryHealthStatementComponent } from './components/beneficiary-health-statement';
import { BeneficiaryPlansComponent } from './components/beneficiary-plans';
import { BeneficiaryPlanCardComponent } from './components/beneficiary-plans/beneficiary-plan-card';
import { CancelamentoImediatoComponent } from './components/cancelamento-imediato';
import { DadosDeCobrancaComponent } from './components/dados-de-cobranca';
import { ModalCancelamentoImediatoComponent } from './components/modal-cancelamento-imediato';
import { ShowBeneficiaryComponent } from './components/show-beneficiary/show-beneficiary.component';
import { TabelaAlteracaoCadastralComponent } from './components/tabela-alteracao-cadastral';
import { TabelaCancelamentoImediatoComponent } from './components/tabela-cancelamento-imediato';
import { DpsQuestionsService } from './services/dpsQuestions';

@NgModule({
  declarations: [
    TabelaAlteracaoCadastralComponent,
    AlteracaoCadastralComponent,
    DadosDeCobrancaComponent,
    CancelamentoImediatoComponent,
    TabelaCancelamentoImediatoComponent,
    ModalCancelamentoImediatoComponent,
    BeneficiaryFormComponent,
    BeneficiaryDocumentsComponent,
    BeneficiaryDocumentInputComponent,
    BeneficiaryPlansComponent,
    BeneficiaryPlanCardComponent,
    BeneficiaryHealthStatementComponent,
    ShowBeneficiaryComponent,
    BeneficiaryBlockComponent,
  ],
  imports: [
    CommonModule,
    DadosCadastraisRoutingModule,

    ComponentsModule,
    PipesModule,

    FormsModule,
    ReactiveFormsModule,

    MatTableModule,
    MatCardModule,
    MatRadioModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    MatStepperModule,
    FontAwesomeModule,
    MatPaginatorModule,

    NgxMaskModule,
  ],

  providers: [ImmediateCancellationService, ClientService, KinshipService, DocumentService, DpsQuestionsService],
})
export class DadosCadastraisModule {}
